import React, { useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";

const ProfileUpdate = () => {
  const [activeTab, setActiveTab] = useState("members");
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleTabSwitch = (tabName) => {
    setActiveTab(tabName);
    setFile(null); // clear file when switching tabs
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first");
      return;
    }

    setUploading(true);

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      console.log("Parsed Data:", jsonData);

      for (const row of jsonData) {
        try {
          const formData = new FormData();

          if (activeTab === "members") {
            // Member fields
            formData.append("member_name", row.member_name);
            formData.append("member_code", row.member_code);
            formData.append("member_phone", row.member_phone);
            formData.append("member_email", row.member_email);
            formData.append("member_password", row.member_password);
            formData.append("date_of_expire", row.date_of_expire);
            formData.append("photo_image", row.photo_image || "");
            formData.append("resume", row.resume || "");
            formData.append("id_card_proof", row.id_card_proof || "");
            formData.append("other_documents", row.other_documents || "");
            formData.append("geolocation", row.geolocation);
            formData.append("specialisation", row.specialisation);
            formData.append("address", row.address);
            formData.append("city", row.city);
            formData.append("state", row.state);
            formData.append("pincode", row.pincode);
            formData.append("technology", row.technology);
            formData.append("roll_number", row.roll_number);
            formData.append("class_member", row.class_member);
            formData.append("discipline", row.discipline);
            formData.append("membergroup", row.membergroup);
            formData.append("membercategory", row.membercategory);
            formData.append("membertype", row.membertype);
            formData.append("id_student", row.id_student);
            formData.append("organization_name", row.organization_name);
            formData.append("designation_role", row.designation_role);
            formData.append("country", row.country);
            formData.append("interested_research", row.interested_research);
            formData.append("interested_startup", row.interested_startup);
            formData.append(
              "interested_investments",
              row.interested_investments
            );
            formData.append("interested_mentoring", row.interested_mentoring);
            formData.append(
              "membership_frequency_renewal",
              row.membership_frequency_renewal
            );
            formData.append("skills", row.skills);

            await axios.post(
              "http://localhost:5001/passion-api/api/add/members",
              formData,
              { headers: { "Content-Type": "multipart/form-data" } }
            );
          } else {
            // Opportunity fields
            formData.append("opportunity_type", row.opportunity_type);
            formData.append("organization_name", row.organization_name);
            formData.append("opportunity_title", row.opportunity_title);
            formData.append("eligibility", row.eligibility);
            formData.append("duration", row.duration);
            formData.append("stipend", row.stipend);
            formData.append("location", row.location);
            formData.append("link_to_apply", row.link_to_apply);
            formData.append("last_date_to_apply", row.last_date_to_apply);
            formData.append("contact_details", row.contact_details);
            formData.append("description", row.description);

            await axios.post(
              "http://localhost:5001/passion-api/api/opportunity",
              formData,
              { headers: { "Content-Type": "multipart/form-data" } }
            );
          }

          console.log(`${activeTab} row uploaded successfully`);
        } catch (error) {
          console.error("Error uploading row:", error);
        }
      }

      alert("All rows uploaded successfully");
      setUploading(false);
      setFile(null); // clear file after upload
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div style={{ padding: "30px", maxWidth: "700px", margin: "auto" }}>
      <h2>Excel Upload Portal</h2>

      {/* Tabs */}
      <div style={{ display: "flex", marginBottom: "20px", gap: "10px" }}>
        <button
          onClick={() => handleTabSwitch("members")}
          style={{
            flex: 1,
            padding: "12px",
            backgroundColor: activeTab === "members" ? "#4CAF50" : "#ccc",
            border: "none",
            borderRadius: "5px",
            color: "white",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Members Upload
        </button>
        <button
          onClick={() => handleTabSwitch("opportunities")}
          style={{
            flex: 1,
            padding: "12px",
            backgroundColor: activeTab === "opportunities" ? "#4CAF50" : "#ccc",
            border: "none",
            borderRadius: "5px",
            color: "white",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          Opportunities Upload
        </button>
      </div>

      {/* Upload Section */}
      <div
        style={{
          border: "1px solid #ddd",
          padding: "20px",
          borderRadius: "10px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <h3>
          {activeTab === "members"
            ? "Upload Members Excel"
            : "Upload Opportunities Excel"}
        </h3>

        <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
        <br />
        <br />
        <button
          onClick={handleUpload}
          disabled={uploading}
          style={{
            padding: "10px 20px",
            backgroundColor: "#2196F3",
            border: "none",
            color: "white",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          {uploading ? "Uploading..." : "Upload"}
        </button>
      </div>
    </div>
  );
};

export default ProfileUpdate;
